import { observer } from 'mobx-react-lite';
import Reacr from 'react'
import { Segment, Tab } from 'semantic-ui-react';
import { UserActivity } from '../../app/models/userActivity';
import { useStore } from '../../app/stores/store';
import ProfileAbout from './ProfileAbout';
import ProfileActivities from './ProfileActivities';
import ProfileFollowingsTaggle from './ProfileFollowingsTaggle';
import ProfilePhoto from './ProfilePhotos';

interface Props {
    profile: UserActivity;
 }

function ProfileContent(props: Props) {
    const usStore = useStore();

    const paneArray = [
        //{menuItem: 'About', render: () => <Tab.Pane>About Content</Tab.Pane>},
        //{menuItem: 'About', render: () => <ProfileAbout profile={props.profile} /> }, //.o
        {menuItem: 'About', render: () => <ProfileAbout /> }, //'n
        {menuItem: 'Photos', render: () => <ProfilePhoto profile={props.profile} />},

        //{menuItem: 'Events', render: () => <Tab.Pane>Events Content</Tab.Pane>},
        {menuItem: 'Events', render: () => <ProfileActivities />},

        {menuItem: 'Followers', render: () => <ProfileFollowingsTaggle />},
        {menuItem: 'Following', render: () => <ProfileFollowingsTaggle />},
    ]

    return (
        <Tab 
            menu={{fluid: true, vertical: true}}
            menuPosition='left'
            panes={paneArray}
            onTabChange={(event, data) => usStore.profileStore.setActiveTab(data.activeIndex)} //'n >> ProfileFollowingsTaggle
        />
    )
}

export default observer(ProfileContent);